import React from 'react';
import { translations } from '../../translations';

interface ReferralProps {
  isDarkMode: boolean;
  language: string;
}

export function Referral({ isDarkMode, language }: ReferralProps) {
  const t = translations[language as keyof typeof translations];

  return (
    <div className="p-8">
      <h1 className={`text-2xl font-semibold mb-6 ${
        isDarkMode ? 'text-gray-200' : 'text-gray-900'
      }`}>
        {t.referral}
      </h1>
      <div className={`p-6 rounded-lg border ${
        isDarkMode 
          ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
          : 'bg-white border-[#e5e7eb]'
      }`}>
        <p className={`text-[13px] ${
          isDarkMode ? 'text-gray-400' : 'text-gray-500'
        }`}>
          {t.invite_friends}
        </p>
      </div>
    </div>
  );
}